import React from "react";
import { Modal, Card, CardBody, Col, ModalFooter, Button } from "reactstrap";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  name?: string;
}

const ConfirmDeleteModal: React.FC<Props> = ({
  open,
  onClose,
  onConfirm,
  name,
}) => {
  const { t } = useTranslation();

  return (
    <Modal fade centered isOpen={open} toggle={onClose}>
      <div className="modal-dialog m-0">
        <div className="modal-content">
          <Col xl="12">
            <Card className="social-profile mb-0">
              <CardBody>
                <div className="social-details text-center">
                  <h5>{t("DeleteConfirmation")}</h5>
                  {name && (
                    <span>
                      <h4>{name}</h4>
                    </span>
                  )}
                  <div className="d-flex justify-content-center mt-4">
                    <ModalFooter className="border-0 p-0">
                      <Button color="danger" onClick={onClose} className="me-2">
                        {t("Cancel")}
                      </Button>
                      <Button color="success" onClick={onConfirm}>
                        {t("Confirm")}
                      </Button>
                    </ModalFooter>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
